export default __webpack_public_path__ + "static/media/A Road Walked Together.997c662f.png";